import { createRoute, useEntityUrl } from 'framework/routing';
import { useParams } from 'react-router-dom';

export const PROCESS_DEFINITION_PATH = '/processes/definitions';

export const useProcessDefinitionRoute = () => {
  return createRoute({ listRoute: PROCESS_DEFINITION_PATH });
};

export const useProcessDefinitionUrl = () => {
  return useEntityUrl({ baseLink: PROCESS_DEFINITION_PATH });
};

export const useProcessDefinitionKey = () => useParams<Dictionary<string>>().id!;
